import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 查询阶梯信息
   */
  static queryJFInfo(data) {
    return Request({
      url: `tradecore/promotion/activity/better/gift`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }
  /**
   * 添加商品到购物车
   */
  static addCart(data) {
    let url = `tradecore/trolley/item/add`;
    if (Array.isArray(data)) {
      url = `tradecore/trolley/item/batch/add`;
    } else {
      if (data.fromActiveSource == 1) {
        // 宫主会地址
        url = `tradecore/priaPoints/trolley/item/add/2`;
      }
    }

    return Request({
      url: url,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 添加商品到甄选商城购物车
   */
  static addSelectMallCart(data, type) {
    return Request({
      url: `tradecore/integral/trolley/item/add/${type}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 获取购物车列表
   */
  static getCartList(params) {
    return Request({
      url: `tradecore/trolley/item/list`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取购物车产品关联的活动信息
   */
  static getActivityList(params) {
    console.log('params>>>', params);
    return Request({
      url: `tradecore/trolley/item/specialActivity`,
      method: 'GET',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取购物车商品数量
   */
  static getCartCount() {
    return Request({
      url: `tradecore/trolley/item/count`,
      host: config.HOST_MALL
    });
  }

  // 查询甄选购物车商品数量
  static querySelectMallCartNum() {
    return Request({
      url: 'tradecore/integral/trolley/item/count/0',
      host: config.HOST_MALL
    });
  }

  /**
   * 修改购物车商品数量
   */
  static updateCartItemNum(data) {
    return Request({
      url: `tradecore/trolley/item/update`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 批量删除商品
   */
  static deleteBatch(data) {
    return Request({
      url: `tradecore/trolley/item/batch/delete`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 批量计算活动分组的优惠金额
   */
  static getDiscountBatch(data) {
    return Request({
      url: `tradecore/trolley/calculate/discount/batch/query`,
      host: config.HOST_MALL,
      method: 'post_json',
      data,
      ignoreErr: true
    });
  }

  /**
   * 获取加价购信息
   */
  static getIncPriceShopMsg(data) {
    return Request({
      url: `tradecore/trolley/activity/additional/item/list`,
      host: config.HOST_MALL,
      method: 'post_json',
      data,
      ignoreErr: true
    });
  }

  /**
   * 查询对应活动id的赠品列表
   */
  static getActivityGiftList(params) {
    return Request({
      url: `tradecore/promotion/activity/gift/list`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查询对应活动ids的赠品列表
   */
  static getActivityIdsGiftList(params) {
    // console.log(params,'--tradecore/promotion/activity/gift/list/batch');
    // if (params.activityIds) {
    return Request({
      url: `tradecore/promotion/activity/gift/list/batch`,
      host: config.HOST_MALL,
      data: params,
      method: 'post_json'
    });
    // }
  }

  /**
   * 获取所以商品对应的活动
   */
  static getAllActivityItems(params) {
    return Request({
      url: `tradecore/promotion/item/detail/activity-infos`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询对应活动id的赠品列表
   */
  static getDistributionTip(params) {
    return Request({
      url: `trade/queryOrderProperty`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否绑定过微信
   */
  static queryBindFlag() {
    return Request({
      url: 'user/binding/query/bindFlag',
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 获取跳转链接
   */
  static getWechatLoginUrl(params) {
    return Request({
      url: 'user/login/wechatLoginUrl',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 分享记录
   */
  static ShareCart(params) {
    return Request({
      url: 'tradecore/trolley/item/addShareCartItemInfo',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 通过产品id查多规格商品详情
  static getMoreMultiList(itemCode) {
    return Request({
      // url: `item/multi/item/${itemCode}`,
      url: `item/biz/ext/get/${itemCode}`,
      host: config.HOST_MALL
    });
  }

  // 根据物流获取订单信息
  static getLogistics(params) {
    return new Promise((resolve) => {
      Request({
        url: `biz/tradecore/trade/get-by-logistics`,
        host: config.HOST_MALL
      }).then((res) => {
        if (!(res && res.data)) {
          resolve({ data: { list: [], pageNum: 1, pages: 1 } });
          return;
        }
        const obj = res.data.deliveryAddressMap || {};
        let defaultAddress = null;
        Object.keys(obj).forEach((key) => {
          if (obj[key].defaultAddress) {
            defaultAddress = obj[key];
            defaultAddress.id = defaultAddress.userAddressId;
            defaultAddress.status = 1;
            defaultAddress.detailAddr = [
              defaultAddress.provinceName,
              defaultAddress.cityName,
              defaultAddress.areaName,
              defaultAddress.streetName,
              defaultAddress.communityName,
              defaultAddress.address
            ]
              .filter((e) => e)
              .join('/');
          }
        });
        if (defaultAddress) {
          resolve({ data: { list: [defaultAddress], pageNum: 1, pages: 1 } });
        } else {
          resolve({ data: { list: [], pageNum: 1, pages: 1 } });
        }
      });
    });
  }
  // 获取地址列表
  static getAddressList() {
    return Request({
      url: `tradecore/member/address/queryByPage`,
      host: config.HOST_MALL,
      params: {
        pageSize: 4,
        pageNum: 1
      }
    });
  }

  /**
   * 获取运费
   */
  static getFreight(data) {
    return Request({
      url: 'biz/tradecore/trade/calculate/freight/remind',
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  // 获取推荐产品列表
  static getRecommendProductList(params, data) {
    return Request({
      url: 'es/item/query/browse/page-info',
      host: config.HOST_SEARCH,
      method: 'post_json',
      params,
      data
    });
  }

  // 查询参与促销的活动关闭提示
  static validateSwitchClose(params) {
    return Request({
      url: 'promotion/validateSwitchClose',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/ShoppingCart/ShoppingCartServ.js